"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmOnCloseRequest = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const useConfirmDialog_1 = require("./useConfirmDialog");
function useConfirmOnCloseRequest(onCloseRequest, params) {
    const onClose = react_1.default.useCallback(() => onCloseRequest(), [onCloseRequest]);
    const overridenParams = react_1.default.useMemo(() => (params !== null && params !== void 0 ? params : {
        prompt: catalog_messages_1.Messages.Abandon_Prompt(),
        title: catalog_messages_1.Messages.Abandon_Title(),
        yes: { children: catalog_messages_1.Messages.Abandon_Yes(), testId: 'confirm-abandon' },
        no: { children: catalog_messages_1.Messages.Abandon_No(), testId: 'reject-abandon' },
    }), [params]);
    const { dirty } = (0, formik_1.useFormikContext)();
    const { Dialog, confirm } = (0, useConfirmDialog_1.useConfirmDialog)(overridenParams);
    const abandon = react_1.default.useCallback(() => {
        if (dirty) {
            void confirm().then(response => {
                if (response) {
                    onClose();
                }
            });
        }
        else {
            onClose();
        }
    }, [dirty, confirm, onClose]);
    return { Dialog, abandon };
}
exports.useConfirmOnCloseRequest = useConfirmOnCloseRequest;
//# sourceMappingURL=useConfirmOnCloseRequest.js.map